import { useTranslation } from 'react-i18next'
import Recaptcha from 'react-google-recaptcha';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { Button } from '@mui/material';
import {

    SectionRow,
    SectionInput,
    ContainerInput,
    Input,
    Span,
    SectionBtn,
    LabelCustom,
    ContainerLogin,
    CustomInput,
    SpanLink,
    SubtitleCustom
} from './styles'
import { Link } from 'react-router-dom';
import Router from '../../../../router';
import KeyIcon from '@mui/icons-material/Key';

export const PasswordSection = ({
    showPassword,
    handleClickShowPassword,
    handleMouseDownPassword,
    recaptchaRef,
    handleRecaptchaVerify,
    messageError,
    handleChange,
    handleSubmit,
    form,
    isLoading,
    colors,
}) => {

    const { t } = useTranslation();

    return (
        <ContainerLogin>
            <SubtitleCustom>{t('login.password')}</SubtitleCustom>
            <SectionRow>
                <SectionInput>
                    <LabelCustom>{t('login.stepPassword')}:</LabelCustom>
                    <CustomInput
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        onChange={(e) => handleChange(e, 'password')}
                        required
                        value={form.password}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                            startAdornment: (
                                <InputAdornment position="start">
                                    <KeyIcon sx={{ color: colors.navbarColor }} /> 
                                </InputAdornment>
                            ),
                        }}
                    />
                    <div style={{ textAlign: 'right', marginTop: '4px' }}>
                        <Link to={Router.appPasswordRecovery} state={{ user: form.username }}>
                            <SpanLink>{t('login.forgotPassword')}</SpanLink>
                        </Link>
                    </div>
                </SectionInput>
            </SectionRow>

            <SectionRow>
                <SectionInput>
                    <Span>{messageError}</Span>
                </SectionInput>
            </SectionRow>

            {process.env.REACT_APP_CAPTCHA !== undefined &&
                <SectionRow>
                    <div style={{ margin: '0 auto' }}>
                        <Recaptcha ref={recaptchaRef} sitekey={process.env.REACT_APP_CAPTCHA} onChange={handleRecaptchaVerify} />
                    </div>
                </SectionRow>
            }

            <SectionBtn double>
                <div>
                    <Button
                        variant="contained"
                        sx={{
                            color: colors.white,
                            backgroundColor: colors.buttonActionColor,
                            cursor: 'pointer',
                            padding: '.5em 2em',
                            borderRadius: '5px',
                            display: 'inline-block',
                            justifyContent: 'center',
                            transition: 'all .3s ease-in-out',
                            margin: '2px 0',
                            width: '100%',
                            "&.MuiButton-outlined.Mui-disabled": {
                                background: colors.grayGraphic,
                                cursor: 'not-allowed',
                            },
                            "&:hover": {
                                backgroundColor: colors.buttonActionColor,
                                opacity: 0.8,
                                color: colors.white,
                                transition: 'all .3s ease',
                            },
                            '&:active': {
                                transition: 'all .3s ease',
                                opacity: '1',
                            },
                        }}
                        onClick={() => handleSubmit()}
                        disabled={isLoading || form.reCaptchaToken === null || form.password === ''}
                    >
                        {t('login.login')}
                    </Button>
                </div>
            </SectionBtn>
        </ContainerLogin>
    )
}